import { Pipe, PipeTransform } from '@angular/core';
import { ToolsProvider } from '../../providers/tools/tools';

@Pipe({
  name: 'resizeImage',
})
export class ResizeImagePipe implements PipeTransform {
  constructor(public tools: ToolsProvider) {}

  transform(value: string, ...args) {
    const width = args[0] || 100;
    return this.tools.resizeImage(value, `width=${width}`);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/resize-image/resize-image.ts